import { agentOrderActionTypes } from "../../actionTypes/agentOrder/agentOrder.actionTypes";

// M3: the agent/admin selects the customer they are ordering for. Stored in Redux so the
// cart's handleCreateOrder can place the order against the chosen customer.
export const setSelectedCustomer = (customer) => (dispatch) => {
  dispatch({
    type: agentOrderActionTypes.SET_SELECTED_CUSTOMER,
    data: customer,
  });
};

export const clearSelectedCustomer = () => (dispatch) => {
  dispatch({ type: agentOrderActionTypes.CLEAR_SELECTED_CUSTOMER });
};

const agentOrderActions = {
  setSelectedCustomer,
  clearSelectedCustomer,
};

export default agentOrderActions;
